import type { BoxProps} from '@chakra-ui/react'
import { Link, Text } from '@chakra-ui/react'
import { Ellipsis } from 'BrokerTsLib/src/components'

import { Email } from '@/icons'

interface EmailAddressProps extends BoxProps {
  email: string
  showIcon?: boolean
}

export const EmailAddress = ({ email, showIcon = false, ...rest }: EmailAddressProps) =>
  <Link _hover={{ textDecoration: 'none' }} href={`mailto:${email}`} >
    <Ellipsis as={Text} {...rest} alignItems='center'>
      {showIcon && <Email mr={2} mt={-.5} />}
      {email}
    </Ellipsis>
  </Link>